<template>
    <el-config-provider :locale="locale">
        <el-container class="annt-main">
            <el-aside class="annt-aside" width="auto">
                <annt-sidebar>
                    <template #logo>
                        <img alt="logistic" class="logo" v-if="isCollapse" src="@/assets/annto_logo.png" />
                    </template>
                    <template #logoDetail>
                        <img
                            alt="logistic"
                            class="logo-detail"
                            v-if="!isCollapse"
                            src="@/assets/logo.png"
                            width="210"
                            height="60" />
                    </template>
                </annt-sidebar>
            </el-aside>
            <el-container>
                <el-header class="annt-app-header" height="50px">
                    <annt-header>
                        <template v-slot:tagview>
                            <annt-tags-view :isShowTagsView="true" :indexPage="indexPage" :maxLength="10" />
                        </template>
                        <template v-slot:funcMenu>
                            <annt-func-menus :isShowTagsView="true" />
                        </template>
                    </annt-header>
                </el-header>
                <el-main class="annt-container">
                    <router-view v-slot="{ Component }">
                        <keep-alive :exclude="excludedViews">
                            <component :is="Component" />
                        </keep-alive>
                    </router-view>
                </el-main>
            </el-container>
            <!-- 异常提醒 -->
            <abnormal-warning />
            <!-- 公告弹框 -->
            <notification-modal />
            <!-- IT5000 -->
            <feed-back
                v-if="part3CompWaithed && feedBackConfig.userInfo.token"
                :env="feedBackConfig.env"
                :tabs="feedBackConfig.tabs"
                :componentBottom="feedBackConfig.componentBottom"
                :userInfo="feedBackConfig.userInfo"
                :classify="feedBackConfig.classify"
                :configInfo="feedBackConfig.configInfo"
                :helpInfo="feedBackConfig.helpInfo"></feed-back>
        </el-container>
    </el-config-provider>
</template>

<script>
import { defineAsyncComponent, defineComponent } from 'vue'
import AnntHeader from '@/components/core/header/Header.vue'
import AnntSidebar from '@/components/core/sidebar/Sidebar.vue'
import AnntTagsView from '@/components/core/tagsView/TagsView.vue'
import AnntFuncMenus from '@/views/dashbord/FunctionalMenus.vue'
import AbnormalWarning from '@/views/dashbord/AbnormalWarning.vue'
import NotificationModal from './NotificationModal.vue'
import { mapState } from 'vuex'
import config from '@/config/user.env.js'
import { getAuthToken, getVouTokenId } from '@/api/user.api.js'

export default defineComponent({
    name: 'Main',
    // eslint-disable-next-line max-lines-per-function
    data() {
        // 由于feedback提供者没有uat和ver环境，只有sit环境，这里增加一个storage配置，方便在uat环境和ver环境使用
        const feedbackEnv = () => {
            const env = window.sessionStorage?.getItem?.('feedbackEnv') || config.env.toLowerCase()
            return ['dev', 'sit', 'uat'].includes(env) ? 'uat' : env
        }
        // console.log('this.$store.state.user...', this.$store.state.user);
        return {
            indexPage: '/mod/ntp/index',
            part3CompWaithed: false,
            feedBackConfig: {
                env: feedbackEnv(),
                componentBottom: 400,
                tabs: [
                    {
                        unique: 'G5000',
                        name: 'IT5000',
                        icon: 'feedback-tool-filled',
                        jumpUrl: '',
                    },
                    {
                        unique: 'message',
                        name: '我的消息',
                        icon: 'feedback-message',
                        jumpUrl: '',
                    },
                    {
                        unique: 'advice',
                        name: '我要建议',
                        icon: 'feedback-edit-filledbeifen',
                        jumpUrl: '',
                    },
                    {
                        unique: 'help',
                        name: '帮助中心',
                        icon: 'feedback-question',
                        jumpUrl: '',
                    },
                ],
                userInfo: {
                    user: 'NTP_wanghuo',
                    token: '',
                    productId: config.productId,
                    systemId: config.systemId,
                    appId: config.feedbackAppId,
                    messageSystem: 'C-NTP',
                },
                classify: {
                    oneClassifyCode: 'yyyw', // 项目的一级分类
                    twoClassifyCode: config.twoClassifyCode, // 项目的二级分类
                    threeClassifyCode: config.threeClassifyCode, // 项目的三级分
                },
                configInfo: {
                    isMobile: true,
                    screenshotsMode: 2,
                    version: 1,
                    channelCode: 'C_NTP',
                    isAdviceMobile: true,
                    isRequiredAdviceMobile: true, // true-【联系方式】必填
                },
                helpInfo: {
                    systemName: 'C-NTP-HZ', // 系统名称
                    relateId: 0, // 文档id
                },
            },
        }
    },
    components: {
        AnntHeader,
        AnntSidebar,
        AnntTagsView,
        AnntFuncMenus,
        AbnormalWarning,
        NotificationModal,
        FeedBack: defineAsyncComponent(() => import('itsm-feedback-v3')),
    },
    created() {
        getVouTokenId({
            source: '2', // 来源：1为平台端， 2为货主端
            mipCode: '', // mip账号：货主端用户没有mip账号，由后端接口统一使用固定mip，这里传空即可
        })
            .then(res => {
                if (res && +res.code === 0) {
                    this.feedBackConfig.userInfo.token = res.data
                    this.feedBackConfig.configInfo.isShowJumpBtn = true
                    // console.log('this.feedBackConfig.userInfo.token...', this.feedBackConfig.userInfo.token);
                }
            })
            .catch(err => {
                console.error(err)
            })
    },
    mounted() {
        // 第三方组件等待3秒再加载
        setTimeout(() => {
            this.part3CompWaithed = true
        }, 3000)
    },
    computed: {
        isCollapse() {
            return this.$store.state.user.isCollapse
        },
        ...mapState({
            locale: state => state.user.langInfo[state.user.locale],
        }),
        excludedViews() {
            // console.log('this.$store.getters.shouldCloseViews', this.$store.getters.shouldCloseViews.map(v => v.name))
            // console.log('this.$store.getters.keepaliveExclucdedViews', this.$store.getters.keepaliveExclucdedViews.map(v => v.name))
            return ['index', 'OrderPlace', 'OrderTrace', 'SourcePlace', 'WaybillDetail'].concat(
                this.$store.getters.keepaliveExclucdedViews.map(view => view.name), // this.$store.state.keepalive.excludedViews,
            )
        },
    },
})
</script>

<style lang="less">
@import '../../style/scrollbar.less';
@import '../../style/aside.less';
@import '../../style/main.less';
@import '../../style/customer.less';
@import '../../style/base.less';
@import '../../style/theme.less';
@import '../../style/annto-style.less';

.logo-detail {
    margin-left: -20px;
}
</style>
